import {
  withJsonFormsControlProps,
  withJsonFormsLayoutProps,
} from '@jsonforms/react'
import { rankWith, and, scopeEndsWith } from '@jsonforms/core'
import { ModalSystem } from '../container/Modal'
import {
  CardSystem,
  SubCardSystem,
} from 'designer/component/control/container/Card'
import {
  CollapseSystem,
  SubCollapseSystem,
} from 'designer/component/control/container/Collapse'
import {
  PanelSystem,
  SubPanelSystem,
} from 'designer/component/control/container/Panel'
import {
  SubTabSystem,
  TabSystem,
} from 'designer/component/control/container/Tab'
import {
  TabPanelSystem,
  SubTabPanelSystem,
} from 'designer/component/control/container/TabPanel'
import {
  DynamicSystem,
  SubDynamicSystem,
} from 'designer/component/control/container/Dynamic'
import {
  DynamicSystemPanel,
  SubDynamicSystemPanel,
} from 'designer/component/control/container/DynamicPanel'
import {
  EditSystemPanel,
  SubEditSystemPanel,
} from 'designer/component/control/container/EditPanel'
import {
  SubPanelGroupSystem,
  PanelGroupSystem,
} from 'designer/component/control/container/PanelGroup'

const cardTester = rankWith(
  3,
  and(scopeEndsWith('card'), (schema) => !schema.subGroup)
)
const subCardTester = rankWith(
  3,
  and(scopeEndsWith('card'), (schema) => schema.subGroup)
)
const collapseTester = rankWith(
  3,
  and(scopeEndsWith('collapse'), (schema) => !schema.subGroup)
)
const subCollapseTester = rankWith(
  3,
  and(scopeEndsWith('collapse'), (schema) => schema.subGroup)
)
const panelTester = rankWith(
  3,
  and(scopeEndsWith('panel'), (schema) => !schema.subGroup)
)
const subPanelTester = rankWith(
  3,
  and(scopeEndsWith('panel'), (schema) => schema.subGroup)
)
const tabTester = rankWith(
  3,
  and(scopeEndsWith('tab'), (schema) => !schema.subGroup)
)
const subTabTester = rankWith(
  3,
  and(scopeEndsWith('tab'), (schema) => schema.subGroup)
)
const tabPanelTester = rankWith(3, scopeEndsWith('tabPanel'))
const dynamicTester = rankWith(
  3,
  and(scopeEndsWith('dynamic'), (schema) => !schema.subGroup)
)
const subDynamicTester = rankWith(
  3,
  and(scopeEndsWith('dynamic'), (schema) => schema.subGroup)
)
const dynamicPanelTester = rankWith(3, scopeEndsWith('dynamicPanel'))
const editPanelTester = rankWith(3, scopeEndsWith('editPanel'))
const modalTester = rankWith(3, scopeEndsWith('modal'))
const panelGroupTester = rankWith(
  3,
  and(scopeEndsWith('panelGroup'), (schema) => !schema.subGroup)
)
const subPanelGroupTester = rankWith(
  3,
  and(scopeEndsWith('panelGroup'), (schema) => schema.subGroup)
)

const Card = (props) => <CardSystem {...props} />
const SubCard = (props) => <SubCardSystem {...props} />
const Collapse = (props) => <CollapseSystem {...props} />
const SubCollapse = (props) => <SubCollapseSystem {...props} />
const Panel = (props) => <PanelSystem {...props} />
const SubPanel = (props) => <SubPanelSystem {...props} />
const Tab = (props) => <TabSystem {...props} />
const SubTab = (props) => <SubTabSystem {...props} />
const TabPanel = (props) => <TabPanelSystem {...props} />
const SubTabPanel = (props) => <SubTabPanelSystem {...props} />
const Dynamic = (props) => <DynamicSystem {...props} />
const SubDynamic = (props) => <SubDynamicSystem {...props} />
const DynamicPanel = (props) => <DynamicSystemPanel {...props} />
const SubDynamicPanel = (props) => <SubDynamicSystemPanel {...props} />
const EditPanel = (props) => <EditSystemPanel {...props} />
const SubEditPanel = (props) => <SubEditSystemPanel {...props} />
const Modal = (props) => <ModalSystem {...props} />
const PanelGroup = (props) => <PanelGroupSystem {...props} />
const SubPanelGroup = (props) => <SubPanelGroupSystem {...props} />

export const containerSystemRenderer = {
  modal: {
    tester: modalTester,
    renderer: withJsonFormsControlProps(Modal),
  },
  main: {
    card: {
      tester: cardTester,
      renderer: withJsonFormsControlProps(Card),
    },
    collapse: {
      tester: collapseTester,
      renderer: withJsonFormsControlProps(Collapse),
    },
    panel: {
      tester: panelTester,
      renderer: withJsonFormsControlProps(Panel),
    },
    tab: {
      tester: tabTester,
      renderer: withJsonFormsControlProps(Tab),
    },
    tabPanel: {
      tester: tabPanelTester,
      renderer: withJsonFormsLayoutProps(TabPanel),
    },
    dynamic: {
      tester: dynamicTester,
      renderer: withJsonFormsControlProps(Dynamic),
    },
    dynamicPanel: {
      tester: dynamicPanelTester,
      renderer: withJsonFormsControlProps(DynamicPanel),
    },
    editPanel: {
      tester: editPanelTester,
      renderer: withJsonFormsControlProps(EditPanel),
    },
    panelGroup: {
      tester: panelGroupTester,
      renderer: withJsonFormsControlProps(PanelGroup),
    },
  },
  sub: {
    card: {
      tester: subCardTester,
      renderer: withJsonFormsControlProps(SubCard),
    },
    collapse: {
      tester: subCollapseTester,
      renderer: withJsonFormsControlProps(SubCollapse),
    },
    panel: {
      tester: subPanelTester,
      renderer: withJsonFormsControlProps(SubPanel),
    },
    tab: {
      tester: subTabTester,
      renderer: withJsonFormsControlProps(SubTab),
    },
    tabPanel: {
      tester: tabPanelTester,
      renderer: withJsonFormsLayoutProps(SubTabPanel),
    },
    dynamic: {
      tester: subDynamicTester,
      renderer: withJsonFormsControlProps(SubDynamic),
    },
    dynamicPanel: {
      tester: dynamicPanelTester,
      renderer: withJsonFormsControlProps(SubDynamicPanel),
    },
    editPanel: {
      tester: editPanelTester,
      renderer: withJsonFormsControlProps(SubEditPanel),
    },
    panelGroup: {
      tester: subPanelGroupTester,
      renderer: withJsonFormsControlProps(SubPanelGroup),
    },
  },
}
